export enum _AUTH_STORE {
  LOGIN = 'AuthStore/login',
  GET_USER_LOGGED = 'AuthStore/getUserLogged',
  SET_SESSION = 'AuthStore/setSession',
  CLEAN_SESSION = 'AuthStore/cleanSession',
}

export enum ROLES {
  ADMIN = 'ADMIN',
  USER = 'USER',
  SYS_MONITOR = 'SYS_MONITOR',
  EDUAC_GUEST = 'EDUAC_GUEST',
  TECH_SUPPORT = 'TECH_SUPPORT',
  SCHOOL_DISTRICT_ADMIN = 'SCHOOL_DISTRICT_ADMIN',
  SCHOOL_ADMIN = 'SCHOOL_ADMIN',
  CALENDAR = 'CALENDAR',
  EDUAC_USER_ADMIN = 'EDUAC_USER_ADMIN',
  EDUAC_STUDENT = 'EDUAC_STUDENT',
  EDUAC_TEACHER = 'EDUAC_TEACHER',
  JOBS = 'JOBS',
  JITSI = 'JITSI',
  EDUAC_SUBSTITUTE_TEACHER = 'EDUAC_SUBSTITUTE_TEACHER',
  EDUAC_AUTHOR = 'EDUAC_AUTHOR',
}